import {
    userVerificationContract,
    RequestVerificationRequest,
} from "@common/contracts/user-verification.contract";
import { getBackendAPIClient } from "./backendAPIClient";

const userVerificationContractClient = getBackendAPIClient(
    userVerificationContract,
);

export async function requestIdentityVerification(
    data: RequestVerificationRequest,
): Promise<void> {
    await userVerificationContractClient.requestIdentityVerification({
        body: data,
    });
}
